<template>
	<div>
		<v-app-bar fixed light dense >
      <v-btn icon :to="`/i/${this.$route.params.id}/en`">
        <v-icon >mdi-chevron-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ this.category.nameFR }} {{ this.category.subtitleFR }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>

		<v-row justify="center">

			<v-col cols="12" sm="6">
				<v-list v-if='!loading'>
					<v-subheader> </v-subheader>
					<v-list-item
						v-for="(item,index) in cart"
						:key="index"
						align-self='start'
					>
						<v-list-item-avatar tile class="rounded-card align-self-start pt-4" v-if="showAvatar">
							<img :src="item.image != '' ? item.image : notImage"/>
						</v-list-item-avatar>

								<v-list-item-content >

								<p align="left" class="name" >{{item.nameFR}} </p><hr>
								<p align="left" class="description">{{item.descriptionFR}} </p>
								<p align="left" class="description">{{item.description1FR}} </p>
								<p align="left" class="description">{{item.description2FR}} </p>

								<v-row  class=" px-3 pt-3">

										<p   v-for="aler in  item.alergenos" :key="aler.id" >
										<img style=" max-width: 27px; margin: 04px;" class="alergenos" :src="`/static/alergenos/${aler}.jpg`" />
										</p>

								</v-row>

							</v-list-item-content>

						<v-list-item-icon>
							<h4 class="price" v-html="`${item.price}`"/>
						</v-list-item-icon>

					</v-list-item>
				</v-list>
				<v-container v-else fill-height>
					<v-layout flex align-center justify-center>
						<v-progress-circular indeterminate :size="100" :widht="45" color="primary" />
					</v-layout>
				</v-container>
			</v-col>
	</v-row>
	</div>
</template>
<script>
	import { mapState, mapActions } from "vuex";
	import { db } from "@/main";
  export default {
		name: 'cartList',
		mounted(){
			this.showAvatar = false;
			this.$store.dispatch('setLoaded', false, { root: true })
			if (this.cart.length == 0){
				const refFeat = db.collection('bussiness')
					.doc(this.$route.params.id).collection('items')
					.where('category_id','==', this.$route.params.cat)
					.where('visible','==', true)
					.orderBy('order')

				refFeat.onSnapshot(snap => {
					if (snap.empty) {
						console.log('Not matching documents.')
						return
					}
					this.cart = []
					snap.forEach(doc => {
						this.cart.push( doc.data() )
					})
					this.$store.dispatch('setLoaded', true, { root: true })
					this.loading = false
				})
			}


		},
    data: () => ({
      businessId: '',
			loading: true,
			showAvatar: false,
			notImage: '/static/images/not-found.png',
			cart: [],
		}),
		computed: {
			...mapState(['category']),
		}
  }
</script>

